(() => {
  'use strict';
  if (document.documentElement.lang.toLowerCase().split('-')[0] !== 'en') return;
  const script = document.currentScript;
  if (!script || script.dataset.switoryBound === '1') return;
  script.dataset.switoryBound = '1';
  const rules = [
    ['.header .description.globo-description > p', ['Hinterlassen Sie Ihre Nachricht und wir melden uns in Kürze bei Ihnen.'], 'Leave your message and we will get back to you shortly.'],
    ['label[for="88980-text-2"] > .label-content', ['Menge/Monat', 'Menge/Monat '], 'Quantity per month'],
    ['label[for="88980-text-3"] > .label-content', ['Name der Firma'], 'Company name'],
    ['label[for="88980-textarea"] > .label-content', ['Nachricht'], 'Message'],
    ['[id="88980-text-2-error"] > p.help-block.error', ['Menge/monat  is required'], 'Quantity per month is required'],
    ['[id="88980-textarea-error"] > p.help-block.error', ['Nachricht is required'], 'Message is required']
  ];
  const apply = () => {
    document.querySelectorAll('#globo-formbuilder-88980.globo-formbuilder[data-id="88980"]').forEach(root => {
      const buttons = root.querySelectorAll('button[type="submit"].action.submit');
      if (buttons.length === 1) {
        const texts = Array.from(buttons[0].childNodes).filter(node => node.nodeType === Node.TEXT_NODE && node.data === 'Einreichen');
        if (texts.length === 1) texts[0].data = 'Submit';
      }
      const summaries = root.querySelectorAll('[id="88980-error-summary"].gfb__error-summary');
      if (summaries.length === 1 && summaries[0].childNodes.length === 1 && summaries[0].firstChild.nodeType === Node.TEXT_NODE) {
        const summary = summaries[0].firstChild;
        const match = summary.data.match(/^(There are ([1-7]) problems with your submission: )(.+)$/);
        if (match) {
          const messages = match[3].split('. ');
          const known = ['First name is required', 'Last name is required', 'Email is required', 'Menge/monat  is required', 'Nachricht is required'];
          if (messages.length === Number(match[2]) && messages.every(message => known.includes(message))) {
            const translated = messages.map(message => {
              if (message === 'Menge/monat  is required') return 'Quantity per month is required';
              if (message === 'Nachricht is required') return 'Message is required';
              return message;
            });
            const after = match[1] + translated.join('. ');
            if (summary.data !== after) summary.data = after;
          }
        }
      }
      rules.forEach(([selector, before, after]) => {
        const matches = root.querySelectorAll(selector);
        if (matches.length !== 1) return;
        const element = matches[0];
        if (element.childNodes.length !== 1 || element.firstChild.nodeType !== Node.TEXT_NODE) return;
        const node = element.firstChild;
        if (before.includes(node.data)) node.data = after;
      });
    });
  };
  const start = () => {
    const host = document.getElementById('MainContent');
    if (!host) return;
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      queueMicrotask(() => { scheduled = false; apply(); });
    });
    observer.observe(host, { childList: true, subtree: true, characterData: true });
    apply();
    window.addEventListener('pageshow', apply);
    document.addEventListener('shopify:section:load', apply);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
